import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (ex) { toast.error(formatErr(ex.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif-display text-4xl text-[#1E3F33]">Password dimenticata</h1>
        <p className="mt-2 text-[#6B6B6B]">Inserisci la tua email: ti invieremo un link per reimpostare la password (valido 1 ora).</p>
        {done ? (
          <div data-testid="forgot-done" className="mt-8 card-flat p-6">
            <p className="text-[#2C2C2C]">Se l'email è registrata, riceverai le istruzioni entro pochi minuti. Controlla anche la cartella spam.</p>
            <Link to="/accedi" className="btn-lift inline-block mt-6 px-4 py-2 bg-[#1E3F33] text-white rounded-md">Torna al login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 card-flat p-6 space-y-4">
            <div>
              <label className="label-caps block mb-2">Email</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
            </div>
            <button data-testid="forgot-submit" disabled={loading} className="btn-lift w-full py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24] disabled:opacity-60">
              {loading ? "Invio…" : "Invia link di reset"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
